





























import Vue from "vue";
import Radio from "@/components/basic/fields/Radio.vue";
export default Vue.extend({
  name: "UkraineResidenceInfo",
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      ukraineAddress: true,
      TRANSLATION_KEY: "UkraineResidenceInfo",
    };
  },
  methods: {
    handleRedirect() {
      window.location.replace('https://www.oanda.com/apply/');
    },
    handleEuAddress() {
      this.$emit('yesEuAddress')
    }
  },
  components: {
    Radio,
  }
});
